/**
 * 登录态本地存储读写：与 Taro 版 h5/小程序（order-systrem-buyer-h5）保持同一 storage key（isLogin），
 * 值统一改为 Taro storage 的 { data: boolean } JSON 结构，便于共享域下两端互认登录态。
 *
 * 兼容说明：线上已登录用户的 localStorage.isLogin 仍是旧格式的纯字符串 "true"/"false"，
 * getIsLogin 里同时兼容新旧两种格式，避免升级后把老用户判定为“未登录”。
 */
const STORAGE_KEY = "isLogin";

export function setIsLogin(isLogin) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ data: !!isLogin }));
}

export function getIsLogin() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return false;
  try {
    const parsed = JSON.parse(raw);
    // 新格式：{ data: boolean }
    if (parsed && typeof parsed === "object") {
      return !!parsed.data;
    }
  } catch (e) {
    // 非 JSON，走旧格式兼容分支
  }
  // 旧格式：纯字符串 "true"/"false"
  return raw === "true";
}
